export const addProcessContext = (payload) => {
    
    return {
        type:'ADD_PROCESS_CONTEXT',
        payload
    }
}

export const clearProcessContext = () => {
    return {
        type: 'CLEAR_PROCESS_CONTEXT',
        
    }
}